import { colors } from 'components/styles/variables';
import Link from 'next/link';
import ReactModal from 'react-modal';

function priceRequestModalStyling(): ReactModal.Styles {
  return {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 10000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    content: {
      padding: '24px 16px 16px 16px',
      height: '226px',
      width: '280px',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      inset: 'auto',
    },
  };
}

interface PriceRequestModalProps {
  isPriceRequestModalOpen: boolean;
  closePriceRequestModal: () => void;
}

export default function PriceRequestModal({
  isPriceRequestModalOpen,
  closePriceRequestModal,
}: PriceRequestModalProps): JSX.Element {
  return (
    <>
      <ReactModal
        isOpen={isPriceRequestModalOpen}
        onRequestClose={closePriceRequestModal}
        style={priceRequestModalStyling()}
      >
        <div className="price-request-modal-title">Your request has been sent!</div>
        <div className="price-request-modal-text">
          If you want to check the status of your request, you can visit the Contacted page.
        </div>
        <div className="price-request-modal-cta-container">
          <button className="price-request-modal-cta later-cta" onClick={closePriceRequestModal}>
            Later
          </button>
          <Link
            href="/noindex/contacted"
            style={{
              width: '116px',
              height: '44px',
              textDecoration: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '4px',
              background: colors.ALR1,
              border: 'none',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '22px',
              letterSpacing: '0.2px',
              color: colors.WHITE,
            }}
          >
            Go now
          </Link>
        </div>
      </ReactModal>
      <style jsx>{`
        .price-request-modal-title {
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: 0.2px;
          margin-bottom: 16px;
        }
        .price-request-modal-text {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0.2px;
          text-align: center;
          margin-bottom: 32px;
        }
        .price-request-modal-cta-container {
          display: flex;
          justify-content: center;
        }
        .price-request-modal-cta {
          width: 116px;
          height: 44px;
        }
        .later-cta {
          margin-right: 16px;
          border-radius: 4px;
          border: 1px solid ${colors.G2};
          background: ${colors.WHITE};
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.2px;
        }
        .go-now-cta {
          border-radius: 4px;
          background: ${colors.ALR1};
          border: none;
        }
        .go-now-cta-text {
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.2px;
          color: ${colors.WHITE};
        }
      `}</style>
    </>
  );
}
